// extracted by mini-css-extract-plugin
export default {"content":"q_gIGAM5VALpS6L3PSrq"};